module.exports = __webpack_public_path__ + "img/footer-empty-list-dark.665d7847.svg";